import type { ActivityModule } from '../../core/activity';
import { runVerticalActivity, filterLaidLevels } from '../../shared/vertical-runner';
import levelsData from './levels.json';
import './style.css';

const LEVELS = filterLaidLevels(levelsData.levels);

export const verticalAddition: ActivityModule = {
  id: 'vertical_addition',
  title: 'Soma em coluna',
  description: 'Resolva contas de soma armadas em coluna (2 a 4 dígitos, com e sem vai-um).',
  ageMin: 7,
  ageMax: 11,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/vertical_addition/icon.svg',
  category: 'aritmetica',
  totalLevels: LEVELS.length,
  mount: (ctx) => runVerticalActivity(ctx, {
    operation: 'plus',
    title: 'Soma em coluna',
    activityId: 'vertical_addition',
    levels: LEVELS,
  }),
};
